import { t } from "../../../services/utils";
import React from "react";
import {
  lightBlue900,
  grey600,
  primaryDark10,
} from "../../../constants/colors";
import { calculateTextHeight, htmlLines } from "../../../services/utils";
import { STORY_VIEW_WIDTH } from "../../../constants/values";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import TextField from "@material-ui/core/TextField";
import ProfileImageView from "../../../components/ProfileImageView";
import "./Toolbar.css";
import { Divider } from "@material-ui/core";
class CommentView extends React.Component {
  constructor(props) {
    super(props);
  }
  onChange = (e) => {
    const val = e.target.value;
    this.props.handler.editingComment(this.props.storyId, val);
  };
  onKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (
        this.props.editedComment &&
        this.props.editedComment.trim().length > 0
      ) {
        this.props.handler.addStoryComment(
          this.props.storyId,
          this.props.editedComment.trim(),
          this.props.index
        );
      }
      this.props.handler.editingComment(this.props.storyId, "");
    }
  };
  toggleComment = (e) => {
    const { expanded, storyId, index } = this.props;
    const expandedValue = expanded[`ac-${storyId}`];
    this.props.handler.toggleComments(
      this.props.storyId,
      !expandedValue,
      index
    );
  };
  render = () => {
    let styles = {
      container: {
        height: "100%",
        backgroundColor: "#FAFAFB",
        border: "1px solid #EAE9EF",
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
      },
      innerContainer: {
        padding: "0px 16px 0px 16px",
        fontSize: 16,
        marginTop: 16,
        display: "flex",
      },
      writeComment: {
        padding: "16px 16px 0px 16px",
        display: "flex",
        alignItems: "center",
      },
      firstName: {
        fontSize: 13,
        color: "#524D70",
        fontWeight: 500,
      },
      icon: {
        fontSize: 20,
        color: "#AAAAAA",
        marginRight: 20,
        cursor: "pointer",
      },
      profilePic: {
        marginRight: 16,
      },
      content: {
        paddingBottom: 16,
      },
      moreComments: {
        color: "#524D70",
        textDecoration: "underline",
        cursor: "pointer",
        marginTop: 20,
      },
    };
    let comments = this.props.comments;
    const { expanded, storyId } = this.props;
    const expandedValue = expanded[`ac-${storyId}`];
    if (expandedValue) {
      comments = comments;
    } else {
      comments = comments.slice(0, 2);
    }
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <div style={styles.writeComment}>
            {/* <AccountCircleIcon
              style={{ ...styles.icon, ...{ fontSize: 34, marginRight: 10 } }}
             /> */}
            <ProfileImageView
              photoId={this.props.me?.photo_id}
              style={styles.profilePic}
              circular={true}
              placeholderSize={40}
              size={40}
            />
            <TextField
              id="outlined-full-width"
              placeholder={t("writeAComment")}
              onChange={this.onChange}
              onKeyPress={this.onKeyPress}
              value={this.props.editedComment ? this.props.editedComment : ""}
              style={{
                marginTop: 5,
                backgroundColor: "white",
              }}
              fullWidth
              inputProps={{
                "data-testid": "story-comment-input",
                style: {
                  padding: "10px 20px",
                },
              }}
              variant="outlined"
            />
          </div>
          {comments.length > 0 && (
            <Divider
              style={{
                marginTop: 16,
                width: "100%",
              }}
            />
          )}
          {comments.map((comment, index) => {
            let lines = htmlLines(comment.comment);
            return (
              <div>
                <div
                  style={styles.innerContainer}
                  key={`comment-${index}-${this.props.storyId}`}
                  data-testid="story-comment-item"
                >
                  <ProfileImageView
                    photoId={comment.photo_id}
                    style={styles.profilePic}
                    circular={true}
                    placeholderSize={40}
                    size={40}
                  />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <span style={styles.firstName}>{comment.first_name}</span>
                    {lines}
                  </div>
                </div>
                {index < comments.length - 1 && (
                  <Divider
                    style={{
                      marginTop: 16,
                      width: "100%",
                      color: "#EAE9EF",
                    }}
                  />
                )}
              </div>
            );
          })}
          {this.props.comments.length > 2 && (
            <div
              style={{
                padding: "0px 16px",
              }}
            >
              {!expandedValue ? (
                <div
                  onClick={this.toggleComment}
                  style={styles.moreComments}
                  className="hover"
                  data-testid="story-comments-toggle"
                >
                  {this.props.comments.length - 2}{" "}
                  {t("moreComments")}
                </div>
              ) : (
                <div
                  onClick={this.toggleComment}
                  style={styles.moreComments}
                  className="hover"
                  data-testid="story-comments-toggle"
                >
                  {t("lessComments")}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    );
  };
  static getHeight(props) {
    let width = STORY_VIEW_WIDTH - 16 - 16; // subtracting left and right padding values
    let comments = props.comments;
    const { expanded, storyId } = props;
    const expandedValue = expanded[`ac-${storyId}`];
    if (expandedValue) {
      comments = comments;
    } else {
      comments = comments.slice(0, 2);
    }
    let writeCommentHeight = 44 + 5;
    let commentRowHeight = 0,
      moreCommentsBtnHeight = 0;
    if (props.comments.length > 2) {
      moreCommentsBtnHeight = 42;
    }
    let totalHeight = 0;
    for (let i = 0; i < comments.length; i++) {
      let comment = comments[i];
      let userNameHeight = 18;
      let userAvatarHeight = 48;
      let commentHeight = calculateTextHeight(
        comment.comment.replace(new RegExp("\n", "g"), "\n\n"),
        width,
        {
          fontSize: 16,
        }
      );
      let commentAndRowHeight = userNameHeight + commentHeight;
      commentRowHeight += Math.max(userAvatarHeight, commentAndRowHeight) + 16; // adding marginTop for every comment
    }

    let displayedText = `${props.first_name}: ${props.comment}`;
    let dtHeight = calculateTextHeight(displayedText, width, {
      fontSize: 16,
    });
    totalHeight =
      writeCommentHeight + commentRowHeight + moreCommentsBtnHeight + 16 + 16; // adding top and bottom padding values
    return totalHeight;
  }
}
export default CommentView;
